<p-toolbar id="app-header" *ngIf="loggedIn">
  <div class="p-toolbar-group-left logo">
    <a href="javascript:void(0)" (click)="goHome()"></a>
  </div>
  
  <div class="p-toolbar-group-right">
    <p-button type="button" icon="pi pi-bars" (click)="menu.toggle($event)"></p-button>
    <p-menu #menu [popup]="true" [model]="userMenuItems"></p-menu>
  </div>
</p-toolbar>